import { ICON_TYPES } from '../constants';

export const ArtServiceTwo = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70.423"
      height="83.439"
      viewBox="0 0 70.423 83.439"
    >
      <g
        id="Group_2"
        data-name="Group 2"
        transform="translate(-491.788 -650.784)"
      >
        <path
          id="Path_19"
          data-name="Path 19"
          d="M66.8.484H4.379V32.839H66.8Z"
          transform="translate(491.5 651)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_20"
          data-name="Path 20"
          d="M35.5,82.522V32.789"
          transform="translate(491.5 651)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_21"
          data-name="Path 21"
          d="M7.32,82.523H63.68"
          transform="translate(491.5 651)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_22"
          data-name="Path 22"
          d="M55,4.488H16.173A6.342,6.342,0,0,1,9.793,10.8V22.52a6.342,6.342,0,0,1,6.38,6.307H55a6.342,6.342,0,0,1,6.38-6.307V10.8A6.342,6.342,0,0,1,55,4.488Z"
          transform="translate(491.5 651)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_23"
          data-name="Path 23"
          d="M35.59,22.646a5.99,5.99,0,1,0-6.058-5.989A6.024,6.024,0,0,0,35.59,22.646Z"
          transform="translate(491.5 651)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_24"
          data-name="Path 24"
          d="M70.011,38.8A27.833,27.833,0,0,0,50.72,42.354a27.3,27.3,0,0,0-12.052,15.31,27.832,27.832,0,0,0,19.291-3.549A27.3,27.3,0,0,0,70.011,38.8Z"
          transform="translate(491.5 651)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_25"
          data-name="Path 25"
          d="M35.8,59.159,58.664,46.051"
          transform="translate(491.5 651)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_26"
          data-name="Path 26"
          d="M.988,51.856A27.832,27.832,0,0,1,20.279,55.4a27.3,27.3,0,0,1,12.052,15.31A27.832,27.832,0,0,1,13.04,67.165,27.3,27.3,0,0,1,.988,51.856Z"
          transform="translate(491.5 651)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_27"
          data-name="Path 27"
          d="M35.2,72.21,12.336,59.1"
          transform="translate(491.5 651)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
      </g>
    </svg>
  );
};

ArtServiceTwo.iconType = ICON_TYPES.ART_SERVICE_TWO;
